import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import AppSentinelsConfigListing from './AppSentinelsConfigListing'
import AppSentinelsCredentialForm from './AppSentinelsCredentialForm'

export default function AppSentinelsPullAndPushView   (props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={AppSentinelsCredentialForm}
            PullConfigListingView={AppSentinelsConfigListing}
        />
    )
}